import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'
import moment from 'moment-timezone'
import queryString from 'query-string'

function getCaptivePortalUserDetails (filter) {
  let {startDate, endDate, storeNames} = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    startDate: startDateParam,
    endDate: endDateParam
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/captive-portal-users/filter?${query}`, {
    credentials: 'include',
    method: 'GET'
  }).then(res => res.json())
}

function exportCaptivePortalUsers (query) {
  return fetch(window.open(`${casaApiUrl}/users/json-to-csv/captive-portal?${query}`), {
    credentials: 'include',
    method: 'GET'
  }).then(res => {
    return res
  })
}

export default {
  getCaptivePortalUserDetails,
  exportCaptivePortalUsers
}



// WEBPACK FOOTER //
// ./src/services/captive-portal-servie.js